module.exports = __webpack_public_path__ + "static/media/historic_alert_marker.910efbae.svg";